import { liff } from '@line/liff';
import { env } from '~/env';

// liff インスタンスを再エクスポート
export { liff };

export const initLiff = () => {
  return liff.init({
    liffId: env.VITE_LIFF_ID,
    withLoginOnExternalBrowser: true,
  });
};

/**
 * ユーザーとLINE公式アカウントの友だち関係を返す
 *
 * NOTE: `localFallbackValue` が指定された場合、ローカル開発環境ならエラー時にその値を返す
 *
 * @returns 友だちの場合は true、そうでない場合は false
 * @see https://developers.line.biz/ja/reference/liff/#get-friendship
 */
export const isFriend = async (localFallbackValue?: boolean) => {
  try {
    return (await liff.getFriendship()).friendFlag;
  } catch (e) {
    if (e instanceof Error) {
      console.error(e.message);
    }

    // ローカル開発環境なら `localFallbackValue` を返す
    if (import.meta.env.DEV && localFallbackValue !== undefined) {
      console.info(
        `[ONLY LOCAL] Using fallback value: isFriend => ${localFallbackValue}`,
      );
      return localFallbackValue;
    }

    throw e;
  }
};
